import { render, staticRenderFns } from "./SmallArrowButton.vue?vue&type=template&id=44b40e75&scoped=true&"
import script from "./SmallArrowButton.vue?vue&type=script&lang=js&"
export * from "./SmallArrowButton.vue?vue&type=script&lang=js&"
import style0 from "./SmallArrowButton.vue?vue&type=style&index=0&id=44b40e75&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b40e75",
  null
  
)

export default component.exports